import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { E as EntityDocumentType } from './Document.js';
import { d as isInRange } from './utils2.js';
import { d as defineCustomElement$4 } from './custom-popper2.js';
import { d as defineCustomElement$3 } from './form-control-error-text2.js';
import { d as defineCustomElement$2 } from './form-control-file2.js';
import { d as defineCustomElement$1 } from './form-control-tooltip2.js';

const voidedCheck = {
    name: "voided_check",
    label: "Upload Voided Check",
    documentType: EntityDocumentType.voidedCheck,
    helpText: "Voided check or bank statement where the legal entity and account number are clearly visible. The check must match the legal entity registering for this merchant account."
};
const bankStatements = {
    name: "bank_statement",
    label: "Upload Bank Statements",
    documentType: EntityDocumentType.bankStatement,
    helpText: "The most recent 3 months of your business’ bank statements. The statements must match the legal entity registering for this merchant account."
};
const balanceSheet = {
    name: "balance_sheet",
    label: "Upload FYE Balance Sheets",
    documentType: EntityDocumentType.balanceSheet,
    helpText: "Please provide the balance sheet that corresponds to the last day of your business' last two fiscal years. For example, 12/31/2022 & 12/31/2023 balance sheets."
};
const governmentId = {
    name: 'government_id',
    label: 'Upload Government ID (optional)',
    documentType: EntityDocumentType.governmentId,
    helpText: "The ID must include a personal address."
};
const profitAndLossStatement = {
    name: "profit_and_loss_statement",
    label: "Upload FYE Profit and Loss Statements",
    documentType: EntityDocumentType.profitAndLossStatement,
    helpText: "Fiscal Year End Profit and Loss statements for your business’ last two fiscal years. For example, FYE 2022 and FYE 2023 profit and loss statements."
};
const ss4 = {
    name: 'ss4',
    label: 'Upload SS4 / Article of Incorporation (optional)',
    documentType: EntityDocumentType.taxReturn,
    helpText: "Please upload the business's SS4 / Article of Incorporation."
};
const other = {
    name: 'other',
    label: 'Upload any other documents (optional)',
    documentType: EntityDocumentType.other,
    helpText: "Please upload any other documents that may be relevant to your business."
};
const inputConfigurations = {
    voidedCheck,
    bankStatements,
    balanceSheet,
    governmentId,
    profitAndLossStatement,
    ss4,
    other
};

const BusinessDocumentUploadInputGroup = /*@__PURE__*/ proxyCustomElement(class BusinessDocumentUploadInputGroup extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.inputConfigs = [
            inputConfigurations.voidedCheck,
            inputConfigurations.governmentId,
            inputConfigurations.ss4,
            inputConfigurations.other,
        ];
        this.paymentVolume = undefined;
        this.inputHandler = undefined;
        this.storeFiles = undefined;
        this.errors = undefined;
    }
    getInputGroup() {
        let volume = parseInt(this.paymentVolume);
        if (isInRange(volume, 250000, 999999)) {
            this.inputConfigs.unshift(inputConfigurations.bankStatements);
        }
        else if (volume >= 1000000) {
            this.inputConfigs.unshift(inputConfigurations.balanceSheet, inputConfigurations.profitAndLossStatement, inputConfigurations.bankStatements);
        }
        return this.inputConfigs;
    }
    componentWillLoad() {
        this.getInputGroup();
    }
    render() {
        const inputsConfig = this.inputConfigs;
        return (h("div", { key: 'e43e94c773b524f5725c75af53db4ceadc0ba172', class: "row gy-3" }, inputsConfig.map(config => (h("div", { class: "col-12 col-md-6" }, h("form-control-file", { name: config.name, label: config.label, helpText: config.helpText, documentType: config.documentType, inputHandler: this.inputHandler, onFileSelected: this.storeFiles, errorText: this.errors[config.name], multiple: true }))))));
    }
}, [0, "justifi-business-document-upload-input-group", {
        "paymentVolume": [1, "payment-volume"],
        "inputHandler": [16],
        "storeFiles": [16],
        "errors": [8]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["justifi-business-document-upload-input-group", "custom-popper", "form-control-error-text", "form-control-file", "form-control-tooltip"];
    components.forEach(tagName => { switch (tagName) {
        case "justifi-business-document-upload-input-group":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BusinessDocumentUploadInputGroup);
            }
            break;
        case "custom-popper":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "form-control-error-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "form-control-file":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "form-control-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { BusinessDocumentUploadInputGroup as B, defineCustomElement as d };
